import baseConfig from './baseConfig'
import {clientCsaveExtensions} from './csaveConfigs'
import type {DSConfig} from '@wix/document-services-types'

const modulesList = [
    'accountPublicAPI',
    'breakpointsPublicAPI',
    'siteSegmentsPublicAPI',
    'pagePublicAPI',
    'pagesGroupPublicAPI',
    'themePublicAPI',
    'globalStylesPublicAPI',
    'cssStylePublicAPI',
    'fontsPublicAPI',
    'componentPublicAPI',
    'innerElementsPublicAPI',
    'refComponentPublicAPI',
    'componentStylePublicAPI',
    'smartBoxesPublicAPI',
    'dataModelPublicAPI',
    'featuresPublicAPI',
    'slotsPublicAPI',
    'statesPublicAPI',
    'triggersPublicAPI',
    'reactionsPublicAPI',
    'stylableEditorPublicAPI',
    'componentsMetaDataPublicAPI',
    'componentsLoaderPublicAPI',
    'actionsAndBehaviorsPublicAPI',
    'siteMetadataPublicAPI',
    'feedbackPublicAPI',
    'savePublicAPI',
    'structurePublicAPI',
    'documentModePublicAPI',
    'menuPublicAPI',
    'componentDetectorPublicAPI',
    'wixappsPublicAPI',
    'tpaPublicAPI',
    'atomicScopesPublicAPI',
    'biPublicAPI',
    'environmentPublicAPI',
    'variantsPublicAPI',
    'transformationsPublicAPI',
    'transitionsPublicAPI',
    'remoteStructureMetaDataPublicApi',
    'renderPluginsPublicApi',
    'mobilePublicAPI',
    'errorsPublicAPI',
    'layoutersPublicAPI',
    'mediaPublicAPI',
    'wixCodePublicAPI',
    'siteMembersPublicAPI',
    'connectionsPublicAPI',
    'appControllerDataPublicAPI',
    'platformPublicAPI',
    'appStudioWidgetsPublicAPI',
    'routersPublicAPI',
    'autosavePublicAPI',
    'deprecationPublicAPI',
    'accessibilityPublicAPI',
    'debugPublicAPI',
    'inlinePopupPublicAPI',
    'snapshotPublicAPI',
    'browserThemeColorPublicAPI',
    'customElementsPublicAPI',
    'multilingualPublicAPI',
    'partnersPublicAPI',
    'classicScrollAnchorsPublicAPI',
    'variablesPublicAPI',
    'scopesPublicAPI',
    'patternsPublicAPI',
    'keyframeEffectPublicAPI',
    'effectsPublicAPI',
    'deprecatedOldBadPerformancePublicAPI',
    'classicResponsiveLayoutPublicAPI',
    'customCSSPublicAPI',
    'aiPublicAPI',
    'externalComponentsPublicAPI',
    'builderComponentsPublicAPI',
    'historyAPI',
    'branchesPublicAPI',
    'observablesPublicAPI'
]
const extensionsList = [
    ...baseConfig.extensionsList,
    'undoRedo',
    'metadata',
    'save',
    'lifecycle',
    'layoutCircuitBreaker',
    'viewerRuntime',
    'contactFormMetaData',
    'appBuilder',
    'documentToViewer',
    'wixapps',
    'accountInfo',
    'commonConfig',
    'seo',
    ...clientCsaveExtensions,
    'componentsByType',
    'partners',
    'componentsRegistry',
    'aiContent'
]

export default {
    ...baseConfig,
    modulesList,
    extensionsList,
    isReadOnly: false,
    noUndo: false,
    runStylesGC: false,
    supportMobile: true,
    loadsMiniSiteManager: true,
    postUpdateOperation: true
} as unknown as DSConfig
